import { render, staticRenderFns } from "./ClientCrash.vue?vue&type=template&id=03d54cfe"
import script from "./ClientCrash.vue?vue&type=script&lang=ts"
export * from "./ClientCrash.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports